import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as yup from 'yup';
import { Formik } from 'formik';
import Dialog from '@mui/material/Dialog';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Dropzone from 'react-dropzone';
import { closePopup } from '../../actions/uiActions';
import { webupload } from '../../actions/userActions';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import CloseIcon from '@mui/icons-material/Close';

class WebUpload extends React.Component {
    state = {
        fileName1: "",
        file1: null,
        fileName2: "",
        file2: null,
        fileName3: "",
        file3: null,
        customerID: "",
        uploadPath: "images"
    }

    componentDidMount() {
        // set default customerID
        this.setState({ customerID: this.props.customerID });
    }

    handleSubmit = (event) => {
        if (event.preventDefault !== undefined) { event.preventDefault(); }
        const data = new FormData();
        data.set('customerID', this.state.customerID)

        if (this.state.fileName1.length > 0) {
            data.set('file', this.state.file1, this.state.uploadPath + "/" + this.state.customerID + "/logo1.png");
            this.props.webupload(data);
        } else {
            data.set('file', this.state.file1);
        }

        if (this.state.fileName2.length > 0) {
            data.set('file', this.state.file2, this.state.uploadPath + "/" + this.state.customerID + "/logo2.png");
            this.props.webupload(data);
        } else {
            data.set('file', this.state.file2);
        }

        if (this.state.fileName3.length > 0) {
            data.set('file', this.state.file3, this.state.uploadPath + "/" + this.state.customerID + "/logo3.png");
            this.props.webupload(data);
        } else {
            data.set('file', this.state.file3);
        }

         
      
    }


    handleClick = (event) => {
        event.preventDefault();
        this.props.closePopup();
    }

    onDrop(file, values, i) {
        if (file.length > 0) {
            let uploadedFileName = file[0]["name"]
      //      console.log(values, i);
            values["name" + i] = uploadedFileName
            if (i == 1) {
                this.setState({
                    file1: file[0],
                    fileName1: uploadedFileName,
                });
            }
            if (i == 2) {
                this.setState({
                    file2: file[0],
                    fileName2: uploadedFileName,
                });
            }
            if (i == 3) {
                this.setState({
                    file3: file[0],
                    fileName3: uploadedFileName,
                });
            }
        }
    }
  
    renderDropTitle1() {
        return (this.state.file1 !== null) ? (<h5>Current File: {this.state.fileName1}</h5>) : (<h5>Drop or Click Here to Upload Logo 1</h5>)
    }

    renderDropTitle2() {
        return (this.state.file2 !== null) ? (<h5>Current File: {this.state.fileName2}</h5>) : (<h5>Drop or Click Here to Upload Logo 2</h5>)
    }

    renderDropTitle3() {
        return (this.state.file3 !== null) ? (<h5>Current File: {this.state.fileName3}</h5>) : (<h5>Drop or Click Here to Upload Logo 3</h5>)
    }

    handleCustomerID = (event) => {
        event.preventDefault()
        this.setState({ customerID: event.target.value })
    }

    populateCustomers = () => {
        return (
            <Select
                className="myInput"
                defaultValue=""
                onChange={this.handleCustomerID}
                value={this.state.customerID}
                displayEmpty
                required
                inputProps={{ 'aria-label': 'Without label' }}
            >
                <MenuItem value="" disabled hidden>Select Customer</MenuItem>

                {this.props.customerList.map((x) => <MenuItem key={x.id} value={x.id}>{x.name}</MenuItem>)}
            </Select>
        )
    }
   
    render() {
        return (<Dialog
            open={true}
            onClose={this.handleClick}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >      <CloseIcon onClick={this.handleClick} className="closePoup" />
            <DialogTitle id="alert-dialog-title" className="changepassdialog">Upload Customer Logos (.png files only)</DialogTitle>
                <DialogContent id="alert-dialog-description">             
                    <Formik
                        initialValues={{
                        name1: '',
                        name2: '',
                        name3: '',
                        
                        }}
                        onSubmit={this.handleSubmit}                 
                    >
                        {({
                            values,
                            handleChange,
                            errors,
                            setFieldTouched,
                            touched,
                            handleSubmit
                        }) => (
                            <form>
                                <div className="passwordResetbox">
                                    <div className="uploadOut">
                                    <Dropzone onDrop={(file) => {
                                        this.onDrop(file, values, 1)
                                    }}>
                                        {({getRootProps, getInputProps}) => (
                                            (this.state.file1 !== null) ? 
                                            (<div id="dropzone1" {...getRootProps()}>
                                                <h5>Current File: {this.state.file1.name}</h5>
                                                <input {...getInputProps()} />
                                            </div>) : 
                                            (<div id="dropzone1" {...getRootProps()}>
                                                <h5>Drop or Click Here to Upload Logo 1</h5>
                                                <input {...getInputProps()} />
                                            </div>)
                                        )}
                                        </Dropzone>
                                    <AddPhotoAlternateIcon />
                                 

                                    <Dropzone onDrop={(file) => {
                                        this.onDrop(file, values, 2)
                                    }}>
                                        {({getRootProps, getInputProps}) => (
                                            (this.state.file2 !== null) ? 
                                            (<div id="dropzone2" {...getRootProps()}>
                                                <h5>Current File: {this.state.file2.name}</h5>
                                                <input {...getInputProps()} />
                                            </div>) : 
                                            (<div id="dropzone2" {...getRootProps()}>
                                                <h5>Drop or Click Here to Upload Logo 2</h5>
                                                <input {...getInputProps()} />
                                            </div>)
                                        )}
                                    </Dropzone>
                                    <AddPhotoAlternateIcon />
                                 

                                    <Dropzone onDrop={(file) => {
                                        this.onDrop(file, values, 3)
                                    }}>
                                        {({getRootProps, getInputProps}) => (
                                            (this.state.file3 !== null) ? 
                                            (<div id="dropzone3" {...getRootProps()}>
                                                <h5>Current File: {this.state.file3.name}</h5>
                                                <input {...getInputProps()} />
                                            </div>) : 
                                            (<div id="dropzone3" {...getRootProps()}>
                                                <h5>Drop or Click Here to Upload Logo 3</h5>
                                                <input {...getInputProps()} />
                                            </div>)
                                        )}
                                    </Dropzone>
                                    <AddPhotoAlternateIcon />

                                </div>
                                <div className="myInputOut">
                                    {this.populateCustomers()} 
                                </div>                                     
                                    <div>
                                        <button type="submit" className="btn" onClick={(e) => handleSubmit(e)}>Submit</button>
                                    </div>
                                </div>
                            </form>
                        )}
                    </Formik>
                </DialogContent>
        </Dialog>
        )
    }
}

function mapStateToProps(state) {
    return {     
        customerList: state.users.customerList,
        customerID: state.users.customerID,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup, webupload }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WebUpload)